<template>
  <div class="wrapper">
    <el-card class="box-card" v-for="(card,index) in update.col.data">
      <div slot="header" class="clearfix">
        <div>{{$t('crs.active.task')}}{{index+1}}</div>
        <div style="float: right" >
          <el-button type="text" @click="addReward()">{{$t('crs.bt.add')}}</el-button>
          <el-button v-if="update.col.data.length > 1" type="text" @click="delReward(index)">{{$t('crs.bt.delete')}}</el-button>
        </div>
      </div>
      <div class="text item">
        <el-form-item :label="$t('crs.active.task')" :required="true">
          <el-select  style="float: left" v-model.number="card.conditionsType" :placeholder="$t('crs.active.selectTask')">
            <el-option v-for="(task,index) in gettaskList(index)" :label="task.name" :value="Number(task.value)" :key="Number(task.value)"></el-option>
          </el-select>
          <el-select v-if="card.conditionsType==1" style="float: left" v-model="card.conditionsProductType"  multiple :placeholder="$t('crs.task.choose')" @change="productTypeChange(card)">
            <el-option
              v-for="item in classList"
              :label="item.label"
              :key="item.value"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select v-if="card.conditionsType==1 && card.conditionsProductType && card.conditionsProductType.length > 0" style="float: left" collapse-tags multiple v-model="card.conditionsValue" :placeholder="$t('crs.task.choose')" @change="selectAll(card)" clearable>
            <el-option
              v-for="(value,key) in getproductList(card.conditionsProductType)"
              :label="value"
              :key="key"
              :value="key"
            />
          </el-select>
          <el-input-number style="float: left" v-if="card.conditionsType==2||card.conditionsType==3" v-model="card.conditionsValue" controls-position="right"></el-input-number>
          <el-col v-if="card.conditionsType==2||card.conditionsType==3" class="line" :span="2"> {{$t("crs.task.hand")}}</el-col>

          <el-input-number style="float: left" v-if="card.conditionsType==4||card.conditionsType==5" v-model="card.conditionsValue" controls-position="right"></el-input-number>
          <el-col v-if="card.conditionsType==4||card.conditionsType==5" class="line" :span="2"> {{$t("crs.task.us")}}</el-col>


          <el-select v-if="card.conditionsType==6" style="float: left" v-model="card.conditionsValue">
            <el-option
              v-for="item in goldenList"
              :label="item.goldenName"
              :key="item.goldenAlias"
              :value="item.goldenAlias"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
    </el-card>
  </div>
</template>

<script>
    import URL from "@/views/crs36/util/url"
  export default {
    name: 'task',
    props:["update"],
    data () {
        return {
            taskList: [
                { name: window.$t("crs.task.taskList1"), value: 1},
                { name: window.$t("crs.task.taskList2"), value: 2},
                { name: window.$t("crs.task.taskList3"), value: 3},
                { name: window.$t("crs.task.taskList4"), value: 4},
                { name: window.$t("crs.task.taskList5"), value: 5},
                { name: window.$t("crs.task.taskList6"), value: 6},
            ],
          goldenList:[],
            classList: [
                {
                    value: "2",
                    label:  window.$t("crs.task.classList2")
                },
                {
                    value: "4",
                    label:  window.$t("crs.task.classList4")
                },
                {
                    value: "5",
                    label:  window.$t("crs.task.classList5")
                },
                {
                    value: "7",
                    label:  window.$t("crs.task.classList7")
                }
            ],
            productMap:{},
            oldProductType:[]
        }
    },
    mounted(){
        this.$axios.get( URL.task.productListUrl).then(res => {
            if (res.code == 0)
            {
              this.productMap = res.result;
                const allSelect = {
                    value: window.$t("crs.task.all"),
                    label: "allSelect"
                };
            }
        });

      this.$axios.get(URL.taskGolden.findByGoldenList).then(res => {
        if (res.code == 0)
        {
          this.goldenList = res.result;
        }
      });
    },
    methods: {
        productTypeChange(card){
            if (!card.conditionsValue || card.conditionsValue.length <= 0) return;
            let arr = [];
            const productList = this.getproductList(card.conditionsProductType);
            for(let i in productList){
                arr.push(i);
            }
            const tempArr = card.conditionsValue.filter(item => {
                return arr.indexOf(item) >= 0;
            });
            this.$set(card,"conditionsValue",tempArr);
        },
        gettaskList(index){
            let tempArr = [];
            for(let i in this.update.col.data){
                //自己已选的，自己仍然可选
                if (this.update.col.data[i].conditionsType && i != index) tempArr.push(this.update.col.data[i].conditionsType);
            }
            if (tempArr.length <= 0) return this.taskList;
            return  this.taskList.filter(item=>{
                return tempArr.indexOf(item.value) < 0;
            });
        },
        getproductList(value){
            if (!value || value.length <= 0) return {};
            let result = {all: "all"};
            for (let i = 0; i < value.length; i++) {
                const productObj = this.productMap[value[i]];
                result = Object.assign(result, productObj);
            }
            return result;
        },
        addReward(){
            if(this.update.col.data.length > 2){
               return  this.$message.error(window.$t("crs.task.errorMessage1"));
            }
            this.update.col.data.push({rewardType:1});
        },
        delReward(index){
            this.update.col.data.splice(index, 1);
        },
        selectAll(card) {
            const productList = this.getproductList(card.conditionsProductType);
            let tempArr = [];
            for(let j in productList){
                tempArr.push(j);
            }
            let all = "all";
            if (this.oldProductType.indexOf(all) >= 0 && card.conditionsValue.indexOf(all) < 0 ){
                //取消全选
                this.$set(card,"conditionsValue",[]);
            }else if (this.oldProductType.indexOf(all) < 0 && card.conditionsValue.indexOf(all) >= 0 ){
                //全选
                let arr = [];
                for(let i in productList){
                    arr.push(i);
                }
                this.$set(card,"conditionsValue",arr);
            }else if(card.conditionsValue.indexOf(all) >= 0){
                if(card.conditionsValue.length < tempArr.length){
                    //干掉全选
                    this.$set(card,"conditionsValue",card.conditionsValue.filter(item=>{
                        return item != all;
                    }));
                }
            }else if(card.conditionsValue.indexOf(all) < 0){
                if(card.conditionsValue.length == (tempArr.length-1)){
                    //添加全选
                    card.conditionsValue.push(all);
                }
            }
            this.oldProductType = card.conditionsValue;
        },
    },
    computed:{
        readonly(){
            return (this.update.updateModel.id && this.update.updateModel.status != -1)?true:false;
        }
    },
  }
</script>
